import {Step, StepLabel, StepConnector, Typography, StepIconProps} from '@mui/material';
import Stepper from '@mui/material/Stepper';
import {Home, Person} from '@mui/icons-material';
import clsx from 'clsx';
import React from 'react';
import {useNavigate} from 'react-router-dom';
import theme, {themeColors} from '../../theme/Theme';

const classes = {
  stepper: {
    padding: theme.spacing(1),
    paddingBottom: theme.spacing(3),
  },

  step: {
    backgroundColor: '#ccc',
    zIndex: 1,
    color: '#fff',
    width: 50,
    height: 50,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
  },

  active: {
    backgroundColor: theme.palette.primary.main,
    boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
  },

  completed: {
    backgroundColor: themeColors.green,
  },

  error: {
    backgroundColor: themeColors.red,
  },

  container: {
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginBottom: (theme as any).spacing(3),
  },
  line: {},
  alternativeLabel: {},
};

const ColorlibStepIcon: (step: leadStep) => React.FC<{
  active: boolean;
  completed: boolean;
  error: boolean;
  icon: number;
}> = (step) => (props) => {
  const {active, completed, error} = props;

  const icons: Record<leadStep, React.ReactNode> = {
    basic: <Person />,
    address: <Home />,
  };

  return (
    <div
      style={{
        ...classes.step,
        ...(active ? classes.active : {}),
        ...(completed && !active ? classes.completed : {}),
        ...(error ? classes.error : {}),
      }}
    >
      {icons[step]}
    </div>
  );
};

export type leadStep = 'basic' | 'address';

const initialLeadSteps: leadStep[] = ['basic', 'address'];

export const LeadStepper: React.FC<{currentStep: leadStep}> = ({currentStep}) => {
  const navigate = useNavigate();
  const index = initialLeadSteps.indexOf(currentStep);
  const getStepUrl = (leadStep: leadStep) => {
    return `./${leadStep}`;
  };
  return (
    <>
      <Stepper
        sx={{...classes.stepper, background: 'none'}}
        nonLinear
        alternativeLabel
        orientation="horizontal"
        activeStep={index}
        connector={
          <ColorlibConnector
            classes={{
              alternativeLabel: clsx(classes.alternativeLabel),
              active: clsx(classes.active),
              completed: clsx(classes.completed),
              line: clsx(classes.line),
            }}
            sx={{top: '18px'}}
          />
        }
      >
        {initialLeadSteps.map((step, _index) => {
          const completed = true;
          const beforeCurrentStep = _index < index;
          return (
            <Step
              completed={beforeCurrentStep}
              key={step}
              onClick={() => {
                if (process.env.NODE_ENV === 'development') {
                  navigate({pathname: `${getStepUrl(step)}`});
                }
              }}
            >
              <StepLabel
                StepIconComponent={
                  ColorlibStepIcon(step) as React.ElementType<StepIconProps>
                }
                style={{
                  textTransform: 'capitalize',
                }}
                error={!completed && beforeCurrentStep}
              >
                <Typography
                  style={{top: -10, position: 'relative', fontWeight: 'bold'}}
                  color="primary"
                >
                  {step}
                </Typography>
              </StepLabel>
            </Step>
          );
        })}
      </Stepper>
    </>
  );
};

const ColorlibConnector = StepConnector;
